import React, { ChangeEvent, useEffect, useState } from 'react'
import { Icon } from '../../components/Icon'
// import Pagination from '../../components/UI/Pagination'

import { Accordion, AccordionItem } from '../../components/UI/UIAccordion'
import Modal from '../../components/UI/UIModal'
import UITextArea from '../../components/UI/UITextArea'
import UITextInput from '../../components/UI/UITextInput'
import '../../App.css'
import {
  UploadResponse,
  meetingDataInterfece,
  meetingDataInterfeceResponse,
  meetingDataResponse,
  meetingFormData,
} from '../../utils/types'
import {
  createMeeting,
  deleteMeeting,
  getAllMeetings,
  updateMeeting,
} from '../../api/admin/meetings'
import { toast } from 'react-toastify'
import { useQuery } from 'react-query'
import Loading from '../../components/UI/Loading'
import {
  // calculatePageCount,
  checkValidation,
  initialData,
} from './utils'
import UIDatePickerv from '../../components/UI/UIDatePickerv'
import { fileUpload } from '../../api/apiService'
import { downloadPDF, lastStr } from '../policy/utils'
import PdfViewer from '../../components/UI/PdfViewer'
import DeleteModal from '../../components/globalComponent/DeleteModal'
import { getErrorMessage } from '../../utils/utils'

const Meeting = () => {
  const [isOpenPdfViewer, setIsOpenPdfViewer] = useState<boolean>(false)
  const [pdfUrl, setPdfUrl] = useState('')
  const [activeIndex, setActiveIndex] = useState<number | null>(null)
  const [isOpen, setIsOpen] = useState(false)
  const [isOpenDelete, setIsOpenDelete] = useState(false)
  const [formData, setFormData] = useState<
    meetingFormData | meetingDataInterfece
  >(initialData)
  const [id, setId] = useState('')
  const [isEdit, setIsEdit] = useState(false)
  const [currentPage, setCurrentPage] = useState<number>(1)
  const [selectedFile, setSelectedFile] = useState<File | null>(null)
  const [isLoading, setIsLoading] = useState<boolean>(false)

  const [startAt, setStartAt] = useState('')
  const [endAt, setEndAt] = useState('')

  const getMeetingData = async (): Promise<meetingDataResponse> => {
    const response = (await getAllMeetings(
      currentPage,
      startAt,
      endAt
    )) as meetingDataInterfeceResponse

    if (response?.status != 'successful') {
      toast.error('Network Error.', {
        position: 'top-right',
      })
    }
    return response?.data
  }

  const meetings = useQuery('policy', getMeetingData)
  const [isOpenMenu, setIsOpenMenu] = useState<boolean[]>(
    new Array(meetings?.data?.data?.length || 1000)?.fill(false)
  )
  const handleItemClick = (index: number) => {
    setActiveIndex(activeIndex === index ? null : index) // Toggle the active state
  }

  const handleToggleMenu = (rowIndex: number) => {
    const updatedMenuState = isOpenMenu.map((isOpen, index) =>
      index === rowIndex ? !isOpen : false
    )
    setIsOpenMenu(updatedMenuState)
  }

  const handleDragOver = (event: { preventDefault: () => void }) => {
    event.preventDefault()
  }

  const handleDrop = async (event: React.DragEvent<HTMLDivElement>) => {
    event.preventDefault()
    const file = event.dataTransfer.files[0]
    if (file) {
      try {
        const response = (await fileUpload({
          file: file,
          category: 'user_document',
        })) as UploadResponse
        toast.success(response?.message, {
          position: 'top-right',
        })
        handleChange('attachments', response?.url)
        setSelectedFile(file)
      } catch (error) {
        setSelectedFile(null)
        handleChange('attachments', '')
        toast.error(getErrorMessage(error, 'Failed to upload file'), {
          position: 'top-right',
        })
      }
    }
  }

  const handleFileChange = async (event: ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0]
    if (file) {
      try {
        const response = (await fileUpload({
          file: file,
          category: 'user_document',
        })) as UploadResponse
        toast.success(response?.message, {
          position: 'top-right',
        })
        handleChange('attachments', response?.url)
        setSelectedFile(file)
      } catch (error) {
        setSelectedFile(null)
        handleChange('attachments', '')
        toast.error(getErrorMessage(error, 'Failed to upload file'), {
          position: 'top-right',
        })
      }
    }
  }

  const handleRemoveFile = () => {
    setSelectedFile(null)
    handleChange('attachments', '')
  }

  // const handlePageChange = (pageNumber: number): void => {
  //   setCurrentPage(pageNumber)
  //   // You can add additional logic here, like fetching data for the new page
  // }

  const handleOpenModal = () => {
    setIsOpen(true)
    setCurrentPage(0)
  }

  const handleCloseModal = () => {
    setIsOpen(false)
    setIsEdit(true)
    setFormData(initialData)
    setIsEdit(false)
  }
  const handleCloseDeleteModal = () => {
    setIsOpenDelete(false)
  }

  const handleChange = (fieldName: string, value: string | string[]): void => {
    setFormData((prevState) => ({
      ...prevState,
      [fieldName]: value,
    }))
  }

  function removeNullEntries<T>(obj: T): Partial<T> {
    const newObj: Partial<T> = {}

    for (const key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        const value = obj[key as keyof T]
        if (value !== null) {
          newObj[key as keyof T] = value
        }
      }
    }

    return newObj
  }

  const createNewMeeting = async (): Promise<void> => {
    setIsLoading(true)
    const response = (await createMeeting(formData)) as {
      status?: string
      data: meetingDataInterfece
    }
    if (response?.status == 'successful') {
      meetings.refetch()
      handleCloseModal()
      setIsEdit(false)
      setFormData(initialData)
      setIsLoading(false)
      toast.success('Meeting Created.', {
        position: 'top-right',
      })
    } else {
      toast.error('Network Error.', {
        position: 'top-right',
      })
      setIsLoading(false)
    }
  }

  const removeMeeting = async (): Promise<void> => {
    try {
      const response = (await deleteMeeting({ id: id })) as {
        status?: string
        data: meetingDataInterfeceResponse
      }
      if (response?.status == 'successful') {
        meetings.refetch()
        setIsEdit(false)

        setIsOpenDelete(!isOpenDelete)
      } else {
        toast.error('Network Error.', {
          position: 'top-right',
        })
      }
    } catch (error) {
      toast.error('An error occurred while deleting partner.', {
        position: 'top-right',
      })
    }
  }
  const editMeeting = async (): Promise<void> => {
    setIsLoading(true)
    const response = (await updateMeeting(
      removeNullEntries(formData) as meetingFormData,
      id
    )) as {
      status?: string
      data: meetingDataInterfece
    }
    if (response?.status == 'successful') {
      meetings.refetch()
      // setIsOpen(!isOpen)
      setIsEdit(false)
      setIsOpen(false)
      setIsLoading(false)
      toast.success('Meeting Updated.', {
        position: 'top-right',
      })
    } else {
      setIsLoading(false)
      toast.error('Network Error.', {
        position: 'top-right',
      })
    }
  }

  useEffect(() => {
    meetings.refetch()
  }, [currentPage, startAt, endAt])

  return (
    <div className={'flex flex-col w-full bg-white h-full rounded-3xl p-8 '}>
      <div
        className={'flex flex-col  gap-10 custom-scrollbar'}
        style={{ height: 'calc(100vh - 100px)', overflow: 'auto' }}
      >
        <div className={'flex w-full justify-between items-start  '}>
          <div className="flex-col w-[50%] gap-[20px]">
            <p className={'text-[18px] text-text2 font-bold '}>Meetings</p>
            {/* <p
              className={
                'text-[14px] font-normal text-text1 leading-[24px] mt-2'
              }
            >
              Please add any meetings that you have had. You can add notes and
              files as well the meeting description.
            </p> */}

            <div className="w-[100%] gap-[10px] items-end justify-between flex mt-2">
              <div className="w-full">
                <UIDatePickerv
                  placeholderText={'Not Specified'}
                  title={'Start'}
                  onChange={(e) => {
                    setStartAt(e.target.value)
                  }}
                  value={startAt}
                // value={formData?.meetingDate}
                />
              </div>
              <div className="w-full">
                <UIDatePickerv
                  placeholderText={'Not Specified'}
                  title={'End'}
                  onChange={(e) => {
                    setEndAt(e.target.value)
                  }}
                  value={endAt}
                />
              </div>
              <div className="w-full">
                <button
                  onClick={() => {
                    setStartAt('')
                    setEndAt('')
                  }}
                  className="w-fit px-[20px] text-white py-[12px] rounded-[100px] gap-2 bg-bluishGreen"
                >
                  Reset
                </button>
              </div>
            </div>
          </div>

          <div
            onClick={handleOpenModal}
            className="gap-[10px] bg-bluishGreen items-center min-w-[95px] text-white px-5 py-3 flex rounded-[72px] cursor-pointer"
          >
            <p className={'font-semibold text-sm leading-6 text-white'}>
              Add New Meeting
            </p>
            <Icon
              name={'IconPlus'}
              strokeWidth={1.1}
              stroke={'white'}
              width={16}
              height={16}
            />
          </div>
        </div>

        {/* <div className="flex justify-center items-center self-start gap-[8px] ">
          <p className={'text-text2 font-semibold text-[14px] '}>Sort by</p>
          <div className="rounded-[72px] bg-gray2 w-[109px] h-[28px] flex justify-center items-center ">
            <p className={'text-text1 font-bold text-[12px]'}>last added</p>
          </div>
        </div> */}
        {/* content container */}
        {meetings.isLoading && (
          <div className="flex justify-center items-center h-screen">
            <Loading size="large" />
          </div>
        )}

        {!meetings.isLoading && (
          <div
            className={'flex flex-col custom-scrollbar'}
            style={{ height: 'calc(100vh - 100px)', overflow: 'auto' }}
          >
            <Accordion>
              {meetings?.data?.data?.map((i, index: number) => (
                <AccordionItem
                  key={i.id}
                  isActive={index == activeIndex}
                  onClick={() => handleItemClick(index)}
                  title={i.title}
                  date={i.meetingDate}
                  menuItems={[
                    {
                      label: 'Edit',
                      onClick: () => {
                        setIsEdit(true)
                        setIsOpen(true)
                        if (i) {
                          const {
                            // eslint-disable-next-line @typescript-eslint/no-unused-vars
                            createdAt,
                            // eslint-disable-next-line @typescript-eslint/no-unused-vars
                            createdBy,
                            // eslint-disable-next-line @typescript-eslint/no-unused-vars
                            id,
                            // eslint-disable-next-line @typescript-eslint/no-unused-vars
                            isDeleted,
                            // eslint-disable-next-line @typescript-eslint/no-unused-vars
                            updatedAt,
                            // eslint-disable-next-line @typescript-eslint/no-unused-vars
                            schoolId,
                            ...formData
                          } = i
                          setId(i.id)
                          setFormData(formData as meetingFormData)
                        }
                      },
                      icon: 'IconEdit',
                      iconColor: '#02698C',
                    },
                    {
                      label: 'Download attachment',
                      onClick: () => {
                        if (!i?.attachmentUrl) return

                        if ((i?.attachmentUrl as unknown as string) == 'IN PROGRESS') {
                          return toast.warning("Scanning the file, please check again in a few seconds.", {
                            position: 'top-right',
                          })
                        }
                        if ((i?.attachmentUrl as unknown as string) == 'NoSuchKey') {
                          return toast.warning("File is removed", {
                            position: 'top-right',
                          })
                        }

                        downloadPDF(i?.attachmentUrl, 'data.pdf')
                      },
                      icon: 'IconDownloadCloud',
                      iconColor: '#02698C',
                    },
                    {
                      label: 'Remove',
                      onClick: () => {
                        setId(i.id)
                        setIsOpenDelete(true)
                      },
                      icon: 'IconTrash',
                      iconColor: '#FF6666',
                      textColor: 'text-textError',
                    },
                  ]}
                  isOpenMenu={isOpenMenu[index]}
                  setIsOpenMenu={setIsOpenMenu}
                  isOpenMenusArray={isOpenMenu}
                  onClickMenu={(e) => {
                    e.stopPropagation()
                    handleToggleMenu(index)
                  }}
                  showIcon={!!i?.attachments}
                >
                  <div className="overflow-hidden rounded-[16px] w-full mb-[30px]">
                    <table className="rounded-[16px] overflow-hidden border w-full border-white">
                      <tbody>
                        <tr className="bg-gray1">
                          {/* Example row */}
                          <td className="bg-gray2 px-4  text-text1 font-semibold text-[14px] w-[30%] h-[48px] py-2 border border-white">
                            Meeting Details
                          </td>
                          <td className="px-4 text-text1 font-semibold text-[14px] h-[48px] py-2 border border-white">
                            {i.details}
                          </td>
                        </tr>
                        <tr className="bg-gray1">
                          {/* Example row */}
                          <td className="bg-gray2 px-4  text-text1 font-semibold text-[14px] w-[30%] h-[48px] py-2 border border-white">
                            Meeting Date
                          </td>
                          <td className="px-4 text-text1 font-semibold text-[14px] h-[48px] py-2 border border-white">
                            {i.meetingDate}
                          </td>
                        </tr>
                        <tr className="bg-gray1">
                          {/* Example row */}
                          <td className="bg-gray2 px-4  text-text1 font-semibold text-[14px] w-[30%] h-[48px] py-2 border border-white">
                            Next Meeting Date
                          </td>
                          <td className="px-4 text-text1 font-semibold text-[14px] h-[48px] py-2 border border-white">
                            {i.nextMeetingDate}
                          </td>
                        </tr>
                        <tr className="bg-gray1">
                          {/* Example row */}
                          <td className="bg-gray2 px-4  text-text1 font-semibold text-[14px] w-[30%] h-[48px] py-2 border border-white">
                            File
                          </td>
                          <td className="px-4 text-text1 font-semibold text-[14px] h-[48px] py-2 border border-white">
                            <div
                              onClick={() => {
                                const url = i?.attachmentUrl

                                if (!url) return



                                if ((url as unknown as string) == 'IN PROGRESS') {
                                  return toast.warning("Scanning the file, please check again in a few seconds.", {
                                    position: 'top-right',
                                  })
                                }
                                if ((url as unknown as string) == 'NoSuchKey') {
                                  return toast.warning("File is removed", {
                                    position: 'top-right',
                                  })
                                }

                                setPdfUrl(`${url || ''}`)
                                setIsOpenPdfViewer(true)
                              }}
                              key={index}
                              className="p-4 w-[268px] h-[48px] flex gap-2 items-center bg-white rounded-lg"
                            >
                              <Icon
                                name="IconFile"
                                width={16}
                                height={16}
                                strokeWidth={2}
                                stroke={'#02698C'}
                              />
                              <p className="text-sm font-semibold text-bluishGreen leading-6 flex-1">
                                {lastStr(i?.attachments)}
                                <span className="text-xs font-medium leading-5 text-text3">
                                  1.7 MB
                                </span>
                              </p>
                              <div
                                className="cursor-pointer "
                                onClick={() => {
                                  if (!i?.attachmentUrl) return

                                  if ((i?.attachmentUrl as unknown as string) == 'IN PROGRESS') {
                                    return toast.warning("Scanning the file, please check again in a few seconds.", {
                                      position: 'top-right',
                                    })
                                  }
                                  if ((i?.attachmentUrl as unknown as string) == 'NoSuchKey') {
                                    return toast.warning("File is removed", {
                                      position: 'top-right',
                                    })
                                  }

                                  downloadPDF(i?.attachmentUrl, 'data.pdf')

                                }
                                }
                              >
                                <Icon
                                  name="IconDownloadCloud"
                                  width={16}
                                  height={16}
                                  strokeWidth={1.5}
                                  stroke={'#67A5B9'}
                                />
                              </div>
                            </div>

                            {/* <div className="p-4 w-[268px] h-[48px] flex gap-2 items-center bg-white rounded-lg">
                                <Icon
                                  name="IconFile"
                                  width={16}
                                  height={16}
                                  strokeWidth={2}
                                  stroke={'#02698C'}
                                />
                                <p className="text-sm font-semibold text-bluishGreen leading-6 flex-1">
                                  {lastStr(i?.attachments)}{' '}
                                  <span className="text-xs font-medium leading-5 text-text3">
                                    1.7 MB
                                  </span>
                                </p>
                                <Icon
                                  name="IconDownloadCloud"
                                  width={16}
                                  height={16}
                                  strokeWidth={1.5}
                                  stroke={'#67A5B9'}
                                />
                              </div> */}
                          </td>
                        </tr>

                        {/* Add more rows as needed */}
                      </tbody>
                    </table>
                  </div>
                </AccordionItem>
              ))}
            </Accordion>
          </div>
        )}
      </div>
      <div className="self-start">
        {/* <Pagination
          currentPage={currentPage}
          totalPages={calculatePageCount(Number(meetings?.data?.count) || 0)}
          onPageChange={handlePageChange}
        /> */}
      </div>
      {/* modal */}
      <Modal isOpen={isOpen} onClose={handleCloseModal}>
        <div
          className={
            'w-[480px] max-h-[80vh] overflow-scroll custom-scrollbar items-center  p-4 flex flex-col gap-4'
          }
        >
          <div
            onClick={handleCloseModal}
            className="flex w-[100%] justify-end cursor-pointer"
          >
            <Icon name={'IconCross'} stroke="#02698C" height={16} width={16} />
          </div>
          <div className="flex items-center w-[100%] justify-center">
            <Icon name={'IconCalanderPlus'} height={56} width={56} />
          </div>
          <div className="flex flex-col gap-2 items-center w-[100%] justify-center">
            <h1 className={'text-text2 text-[18px] font-bold'}>
              {isEdit ? 'Edit Meeting' : 'Add New Meeting'}
            </h1>
            <p className={'text-[14px] text-text1 font-normal'}>
              Please enter the details for the meeting and attach your file(s)
            </p>
          </div>
          <div className="w-[100%] flex-col flex gap-4 mt-[10px]">
            <UITextInput
              label={'Meeting Title*'}
              onChange={(e) => {
                handleChange('title', e.target.value)
              }}
              value={formData?.title}
              onBlur={() => { }}
              placeholder="Please enter title"
              iconName={'none'}
            />
            <UITextArea
              label={'Meeting Details*'}
              onChange={(e) => {
                handleChange('details', e.target.value)
              }}
              value={formData?.details}
              onBlur={() => { }}
              placeholder="Please enter your Description"
              iconName={'none'}
            />
            <div className="w-[100%] gap-[10px] justify-between flex mt-2">
              <div className="w-full">
                <UIDatePickerv
                  placeholderText={'Not Specified'}
                  title={'Meeting Date*'}
                  onChange={(e) => {
                    handleChange('meetingDate', e.target.value)
                  }}
                  value={formData?.meetingDate}
                />
              </div>
              <div className="w-full">
                <UIDatePickerv
                  placeholderText={'Not Specified'}
                  title={'Next Meeting Date'}
                  onChange={(e) => {
                    handleChange('nextMeetingDate', e.target.value)
                  }}
                  value={formData?.nextMeetingDate}
                />
              </div>
            </div>
          </div>
          <div className="flex w-[100%] flex-col gap-1">
            <p className="text-xs font-medium leading-5 text-text5">
              Attachments
            </p>
            {selectedFile ? (
              <div className="w-full p-5 py-3 bg-gray1 rounded-xl flex gap-2">
                <div className="mt-1">
                  <Icon
                    name={'IconFile'}
                    stroke={'#02698C'}
                    strokeWidth={1}
                    height={16}
                    width={16}
                  />
                </div>
                <div className="flex flex-col flex-1 gap-2">
                  <div className="flex gap-2 items-center">
                    <p className="text-sm font-semibold leading-6 text-bluishGreen flex-1 p-0">
                      {selectedFile?.name}
                    </p>
                    <p className="text-xs font-medium leading-5 text-[#01B38B] p-0">
                      Upload Successful
                    </p>
                    <Icon
                      name={'IconCheck'}
                      stroke={'#01B38B'}
                      strokeWidth={1}
                      height={16}
                      width={16}
                    />
                    <div className="cursor-pointer" onClick={handleRemoveFile}>
                      <Icon
                        name={'IconTrash'}
                        stroke={'#02698C'}
                        strokeWidth={1}
                        height={16}
                        width={16}
                      />
                    </div>
                  </div>
                  <div className="rounded-full w-full h-1 bg-[#01B38B]"></div>
                </div>
              </div>
            ) : (
              <div
                onDragOver={handleDragOver}
                onDrop={handleDrop}
                className="w-full p-5 py-3 bg-gray1 rounded-xl flex border-2 border-dashed border-gray3 border-separate border-spacing-3"
              >
                <div className="flex flex-1 items-center gap-2">
                  <Icon
                    name={'IconUploadCloud'}
                    stroke={'#02698C'}
                    strokeWidth={1.5}
                    height={20}
                    width={20}
                  />
                  <p className="font-medium text-xs leading-5 text-text1">
                    Drop your file here or
                  </p>
                </div>
                <label htmlFor="fileInput">
                  <div
                    onClick={() => console.log('file upload')}
                    className="cursor-pointer flex items-center gap-2 bg-bluishGreen p-4 py-3 rounded-full"
                  >
                    <Icon
                      name={'IconUploadCloud'}
                      stroke={'#FFFFFF'}
                      strokeWidth={1.5}
                      height={20}
                      width={20}
                    />
                    <p className="font-medium text-xs leading-5 text-text8">
                      Choose a file to upload
                    </p>
                    <input
                      id="fileInput"
                      type="file"
                      onChange={handleFileChange}
                      style={{ display: 'none' }}
                      accept={'.pdf, .doc, .docx, .jpg, .jpeg, .png, .svg'}
                    />
                  </div>
                </label>
              </div>
            )}
            <p className="text-xs font-medium leading-5 text-text3">
              Maximum file size: 5 mb
            </p>
          </div>

          {isEdit ? (
            <div className="w-[100%] flex-col flex gap-[10px] justify-center items-center">
              <button
                onClick={() => {
                  handleOpenModal()
                  editMeeting()
                }}
                className=" bg-bluishGreen text-white min-h-[48px] w-[100%] font-medium rounded-[72px] text-[14px]  "
              >
                {isLoading ? 'Updating....' : 'Update'}
              </button>
              <button
                onClick={handleCloseModal}
                className=" text-text3 border-textError bg-gray2 min-h-[48px] w-[100%] font-medium rounded-[72px] text-[14px]  "
              >
                Cancel
              </button>
            </div>
          ) : (
            <button
              disabled={checkValidation(formData)}
              onClick={() => {
                handleCloseModal()
                createNewMeeting()
              }}
              className=" disabled:bg-gray1 bg-bluishGreen text-white min-h-[48px] w-[100%] font-medium rounded-[72px] text-[14px]  "
            >
              {isLoading ? 'Saving....' : 'Save'}
            </button>
          )}
        </div>
      </Modal>

      <DeleteModal
        isOpen={isOpenDelete}
        onClose={handleCloseDeleteModal}
        title="Delete Meeting"
        description="  Are you sure you want to delete this Meeting?"
        onConfirm={removeMeeting}
        icon="IconAlertTriangle"
      />
      <PdfViewer
        isOpen={isOpenPdfViewer}
        onClose={() => {
          setIsOpenPdfViewer(false)
        }}
        url={pdfUrl}
        title="PDF Viewer"
      />
    </div>
  )
}

export default Meeting
